import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { ENERGY_INTENSITY_PAGE } from './energy_intensity.js';

mountLearnPage(ENERGY_INTENSITY_PAGE);
